export default "__VITE_ASSET__CDrqy0lj__"